import React from 'react';
import classnames from 'classnames';
import { Chainlink } from 'iconsax-react';
import useForwardedRef from 'hooks/useForwardedRef';
import useRipple from 'hooks/useRipple';

type Props = {
  disabled?: boolean;
  text?: string;
  icon?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'alternative' | 'rounded' | 'success' | 'error';
  backgroundColor?: string;
  contrast?: boolean;
  transparent?: boolean;
  capitalize?: boolean;
  selected?: boolean;
  loading?: boolean;
  small?: boolean;
  tiny?: boolean;
  iconOnRight?: boolean;
  className?: string;
  tabIndex?: number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const Button = React.forwardRef(
  (
    {
      text,
      icon,
      className,
      onClick = () => {},
      variant = 'primary',
      disabled = false,
      contrast = false,
      selected = false,
      backgroundColor,
      loading = false,
      small = false,
      tiny = false,
      transparent = false,
      capitalize = false,
      iconOnRight = false,
      tabIndex = 0
    }: Props,
    ref
  ) => {
    const safeRef = useForwardedRef(ref);
    useRipple(safeRef);

    const style = backgroundColor ? { backgroundColor, borderColor: backgroundColor } : {};

    return (
      <button
        ref={safeRef}
        tabIndex={tabIndex}
        onClick={onClick}
        className={classnames(
          'button',
          'body-2',
          'strong',
          variant,
          { selected },
          { transparent },
          { capitalize },
          { small },
          { tiny },
          { 'icon-only': !!icon && !text },
          { contrast },
          className
        )}
        style={style}
        disabled={disabled || loading}
      >
        {loading ? <Chainlink className="loading" /> : !!icon && !iconOnRight ? icon : null}
        {!!text && text}
        {!!icon && !!iconOnRight && icon}
      </button>
    );
  }
);

export default Button;
